<template>
  <section class="hero">
    <div class="hero-left">
      <p class="hero-eyebrow">Our Story</p>
      <h1 v-if="title" class="hero-title">{{ title }}</h1>
      <h1 v-else class="hero-title">
        Affordable<br /><em>Luxury</em><br />Eyewear
      </h1>
      <p class="hero-sub">
        Founded by David and Neli in 2020, Hooligans Eyewear was built on one
        mission — to help you find the perfect pair of eyewear, easily,
        confidently, and at a great value.
      </p>
      <a :href="shopLink" class="btn-primary">Shop the Collection</a>
    </div>
    <div class="hero-right">
      <MediaSlotImage
        slot-code="about.hero"
        :fallback="heroImage"
        alt="Hooligans Eyewear"
        image-class="hero-img"
        sizes="(max-width: 767px) 100vw, 50vw"
        :width="960"
        :height="1200"
        loading="eager"
        fetchpriority="high"
      />
      <div class="hero-right-overlay"></div>
      <div class="hero-year-badge">
        <span class="yr">EST. 2020</span>
        <span class="yr-label">Hooligans Eyewear</span>
      </div>
    </div>
  </section>
</template>

<script>
import { cdnUrl } from "~/utils/cdn";
import MediaSlotImage from "~/core/components/atoms/media-slot-image/media-slot-image.vue";

export default {
  name: "AboutHero",
  components: { MediaSlotImage },
  props: {
    title: {
      type: String,
      default: "",
    },
    heroImage: {
      type: String,
      default: () => cdnUrl("/image/HOOLIGANS+WEB/About+Us/hero-celine.png"),
    },
    shopLink: {
      type: String,
      default: "/designer-eyewear",
    },
  },
};
</script>
